// extracted by mini-css-extract-plugin
export default {"stripeAlertBanner":"StripeAlertBanner_stripeAlertBanner__NAQe3"};